<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar :title="$t('foorter.top32')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#333" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>

    <!-- Tab 切换 -->
    <div class="tab-bar">
      <div class="tab-item" :class="{ active: index1 }" @click="toStatus(1)">
        {{$t('foorter.top33')}}
      </div>
      <div class="tab-item" :class="{ active: index2 }" @click="toStatus(2)">
        {{$t('foorter.top34')}}
      </div>
    </div>

    <!-- 公告列表 -->
    <div class="content" v-show="index1">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="notice.length === 0" description="" />
        <div class="listItem" v-for="(v,key) in notice" :key="key">
          <div class="listTitle">{{ v.name }}</div>
          <div class="listContent html"><p>{{ v.text }}<br></p></div>
          <div class="listTime"><div class="listTimeText">{{ v.create_time }}</div></div>
        </div>
      </van-pull-refresh>
    </div>

    <!-- 消息列表 -->
    <div class="content" v-show="index2">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="msg.length === 0" description="" />
        <div class="listItem" v-for="(v,key) in msg" :key="key">
          <div class="listTitle">{{ v.name }}</div>
          <div class="listContent html"><p>{{ v.text }}<br></p></div>
          <div class="listTime"><div class="listTimeText">{{ v.create_time }}</div></div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      notice: [],
      msg: [],
      index1: true,
      index2: false,
      loading: false,
      finished: false,
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    getNoticeList() {
      this.$http({
        method: 'get',
        url: 'sys_get_notice_list'
      }).then(res => {
        this.notice = res.data || [];
      });
    },
    getMsgList() {
      this.$http({
        method: 'get',
        url: 'sys_get_msg_list'
      }).then(res => {
        this.msg = res.data || [];
      });
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getNoticeList();
        this.getMsgList();
      }, 500);
    },
    toStatus(id) {
      if (id == 1) {
        this.index1 = true;
        this.index2 = false;
      }
      if (id == 2) {
        this.index1 = false;
        this.index2 = true;
      }
    },
  },
  created() {
    this.getNoticeList();
    this.getMsgList();
  }
};
</script>

<style lang='less' scoped>
.page {
  min-height: 100VH;
  background: #f7f8fa;
}

/* 顶部导航栏 */
.header {
  background: #fff;
}

.nav-bar {
  background: #fff;
  :deep(.van-nav-bar__title) {
    color: #333;
    font-size: 18PX;
    font-weight: 600;
  }
  :deep(.van-icon) {
    color: #333;
  }
}

/* Tab 切换栏 */
.tab-bar {
  display: flex;
  background: #fff;
  border-bottom: 1PX solid #f0f0f0;
}

.tab-item {
  flex: 1;
  text-align: center;
  height: 50PX;
  line-height: 50PX;
  font-size: 15PX;
  color: #666;
  cursor: pointer;
  position: relative;
}

.tab-item.active {
  color: #f53d87;
  font-weight: 600;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 40PX;
  height: 3PX;
  background: #f53d87;
  border-radius: 2PX;
}

/* 内容区域 */
.content {
  padding: 15PX;
  min-height: calc(100VH - 100PX);
  background: #f7f8fa;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #333;
  font-size: 14PX;
}

::v-deep .van-loading__text {
  color: #333;
  font-size: 14PX;
}

/* 列表卡片 */
.listItem {
  margin-bottom: 15PX;
  padding: 20PX 15PX;
  background: #fff;
  border-radius: 12PX;
  box-shadow: 0 4PX 12PX rgba(0, 0, 0, 0.05);
  border: none;
}

.listItem .listTitle {
  font-size: 16PX;
  font-weight: 600;
  color: #222;
  margin-bottom: 10PX;
}

.listItem .listContent {
  padding: 10PX 0;
  color: #666;
  font-size: 14PX;
  line-height: 22PX;
  border-bottom: 1PX solid #f5f5f5;
}

.listItem .listTime {
  display: flex;
  justify-content: flex-end;
  padding-top: 10PX;
}

.listItem .listTime .listTimeText {
  color: #999;
  font-size: 13PX;
}
</style>